import type { ReactNode } from 'react';
import s from './Heading.module.scss';

type HeadingLevel = 1 | 2 | 3 | 4 | 5 | 6;

interface HeadingProps {
  /** Heading level, e.g. 1 for <h1> */
  level: HeadingLevel;
  /** If the html tag needs to be a different heading level than the appearance,
   * use this prop to set the html element's level. This might be needed to e.g. assure
   * there is an h1 on each page for accessibility.
   */
  htmlLevel?: HeadingLevel | null;
  /** Class name to pass to the heading tag */
  className?: string;
  /** Heading text */
  children: ReactNode;
}

/** Renders headings from level 1 - 6 */
function Heading({ level, htmlLevel, className = '', children }: HeadingProps) {
  const tagLevel = htmlLevel ?? level;
  const HeadingTag = `h${tagLevel}` as const;
  const levelClass = `level-${level}` as const;
  return (
    <HeadingTag className={`${s.heading} ${s[levelClass]} ${className}`}>
      {children}
    </HeadingTag>
  );
}

export default Heading;
